var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from "classnames";
// A importer si on veut utiliser le DSFR, sinon on dev nous même
import "@gouvfr/dsfr/dist/component/link/link.css";
import { AsTag } from "../../../common/AsTag";
/**
 * @deprecated utiliser `Link`. Sera supprimé dans une futur Release d'ici fin 2025.
 */
var LinkMj = function (props) {
    var _a;
    var size = props.size, icon = props.icon, iconPosition = props.iconPosition, children = props.children, className = props.className, _b = props.issimple, issimple = _b === void 0 ? true : _b, external = props.external, _c = props.as, as = _c === void 0 ? "a" : _c, to = props.to, remainingProps = __rest(props, ["size", "icon", "iconPosition", "children", "className", "issimple", "external", "as", "to"]);
    var _className = classNames(className, (_a = {
            "fr-link": issimple
        },
        _a["fr-link--".concat(size)] = size,
        _a["fr-link--icon-".concat(iconPosition)] = iconPosition,
        _a["".concat(icon)] = icon,
        _a));
    if (external) {
        return (React.createElement("a", __assign({ className: _className, rel: "noreferrer", target: "_blank", href: to }, remainingProps), children));
    }
    var allProps = __assign({ href: to, to: to }, remainingProps);
    return (React.createElement(AsTag, __assign({ as: as }, allProps, { className: _className }), children));
};
export default LinkMj;
